import { SearchOutlined } from "@ant-design/icons";
import { Col, ConfigProvider, Image, Row, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Text from "../../../components/Text/Text";
import Button from "../../../components/Button/Button";
import Select from "../../../components/Select/Select";
import { image } from "../../../resource";
import { dateFormatter } from "../../../utility/Formatter";
import { CardContainer } from "../../../components/Card/CardContainer";
import Input from "../../../components/Input/Input";
import icon from "../../../resource/icon";
import { unitEntities } from "../../../entities/MasterDataEntity";
import { getMasterUnit } from "../../../datasource/UnitMeaDatasource";
import TablePagination from "../../../components/Table/TablePagination";
import color from "../../../resource/color";
import { roleAtom } from "../../../store/RoleAtom";
import { useRecoilValue } from "recoil";
import { checkPermission } from "../../../components/Permission/Permission";

export const UnitSettingPage: React.FC = () => {
  const navigate = useNavigate();
  const roleData = useRecoilValue(roleAtom);
  const isCreate = checkPermission(["unitSetting", "create"], roleData);
  const isEdit = checkPermission(["unitSetting", "edit"], roleData);

  const pageSize = 6;
  const [page, setPage] = useState<number>(1);
  const [unit, setUnit] = useState<{
    count: number;
    groups: unitEntities[];
  }>({
    count: 0,
    groups: [],
  });
  const [search, setSearch] = useState<string>("");
  const [status, setStatus] = useState<boolean>();
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const getProductUnitList = async () => {
    await getMasterUnit({
      page: page,
      take: pageSize,
      isActive: status,
      sortBy: "updatedAt",
      sortDirection: "DESC",
      search: search,
      company: userProfile?.company,
    }).then((res) => setUnit(res));
  };

  useEffect(() => {
    getProductUnitList();
  }, [status, search, page]);

  const PageTitle = (
    <>
      <Row align='middle' gutter={16}>
        <Col span={20}>
          <Text level={3} fontWeight={700}>
            รายการหน่วยสินค้า
          </Text>
        </Col>
        {isCreate && (
          <Col className='gutter-row' span={4}>
            <Button
              type='primary'
              title='+ เพิ่มหน่วยสินค้า'
              height={40}
              onClick={() => navigate("/generalSettings/CreateUnitSetting/create")}
            />
          </Col>
        )}
      </Row>
      <br />
      <Row justify={"space-between"} gutter={8}>
        <Col span={20}>
          <Input
            placeholder='ค้นหาชื่อหน่วยสินค้า'
            prefix={<SearchOutlined style={{ color: "grey" }} />}
            onChange={(e) => setSearch(e.target.value)}
            autoComplete='off'
            allowClear
          />
        </Col>
        <Col span={4}>
          <Select
            allowClear
            placeholder='สถานะทั้งหมด'
            data={[
              { key: "", value: "", label: "สถานะทั้งหมด" },
              { key: "true", value: "true", label: "เปิดใช้งาน" },
              { key: "false", value: "false", label: "ปิดใช้งาน" },
            ]}
            style={{ width: "100%" }}
            onChange={(e) => {
              setPage(1);
              setStatus(e);
            }}
          />
        </Col>
      </Row>
    </>
  );

  const columns: any = [
    {
      title: "ชื่อหน่วยสินค้า",
      dataIndex: "unitMeasureName",
      key: "unitMeasureName",
      width: "60%",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text style={{ textAlign: "center" }}>{value}</Text>,
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "isActive",
      key: "isActive",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"start"} gutter={8}>
              <Tag color={value ? color.success : color.Disable}>
                {value ? "เปิดใช้งาน" : "ปิดใช้งาน"}
              </Tag>
            </Row>
          ),
        };
      },
    },
    {
      title: "อัปเดตโดย",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text level={5}>{dateFormatter(row, false)}</Text>
              <br />
              <Text level={6} color='Text3'>
                {value || "-"}
              </Text>
            </>
          ),
        };
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      hidden: !isEdit,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"start"} gutter={8}>
              <Col span={6}>
                <Button
                  onClick={() =>
                    navigate(`/generalSettings/CreateUnitSetting/${row.unitMeasureId}`)
                  }
                  typeButton='secondary'
                  icon={<img src={icon.iconEdit} style={{ width: "18px", height: "18px" }} />}
                />
              </Col>
            </Row>
          ),
        };
      },
    },
  ].filter((x) => !x.hidden);
  const customizeRenderEmpty = () => (
    <div style={{ textAlign: "center", padding: "10%" }}>
      <Image src={image.emptyTableBrand} preview={false} style={{ width: 70, height: 70 }} />
      <br />
      <Text color='Text3'>ไม่มีรายการหน่วยสินค้า</Text>
    </div>
  );

  return (
    <>
      <CardContainer>
        {PageTitle}
        <br />
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <TablePagination
            columns={columns}
            data={
              (unit.groups || []).map((el: any, idx: number) => {
                return {
                  ...el,
                  key: el.unitMeasureId,
                  id: (page - 1) * 10 + idx + 1,
                };
              }) || []
            }
            scroll={{ x: "max-content" }}
            pagination={{
              current: page,
              pageSize: 6,
              total: unit?.count || 0,
              onChange: (page) => {
                setPage(page);
              },
            }}
          />
        </ConfigProvider>
      </CardContainer>
    </>
  );
};
